'use es6';

import { MARKETING_EMAIL_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const MarketingEmail = ObjectDefinitionRecord({
  hasAccess: (_, hasScope) => hasScope('email-editor-access'),
  objectTypeId: MARKETING_EMAIL_TYPE_ID,
  referenceObjectType: 'MARKETING_EMAIL_PROPERTIES'
});
export default MarketingEmail;